import {Pipe, PipeTransform} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';

@Pipe({name: 'SafeHtml'})
export class SafeHtmlPipe implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) {
    }

    transform(html) {
        // return this.sanitizer.bypassSecurityTrustStyle(html);
        return this.sanitizeHtml(html);
        // return this.sanitizer.bypassSecurityTrustScript(html);
        // return this.sanitizer.bypassSecurityTrustUrl(html);
        // return this.sanitizer.bypassSecurityTrustResourceUrl(html);
    }

    public sanitizeHtml(html) {
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/htmlUtil/safe-html.pipe.ts